import React from 'react';

const IconArrowUpRight = () => (
  <svg
    aria-hidden="true"
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round">
    <path d="M4 12 12 4" />
    <path d="M6 4h6v6" />
  </svg>
);

export default IconArrowUpRight;
